<template>
  <footer class="footer" :style="{ background: getBackgroundColor }">
    <div class="footer-inner">
      <div class="footer-col">
        <h4 class="footer-heading">Goldschmiede Goldregen</h4>
        <p class="footer-text">Handgefertigter Schmuck aus unserer Ladenwerkstatt in München-Schwabing.</p>
        <div class="footer-social">
          <a target="_blank" href="https://goo.gl/maps/5h8NaW5u3mdTUZFQ7" aria-label="Google Maps – Standort der Goldschmiede Goldregen" rel="noopener">
            <img src="@/assets/imgs/maps.png" alt="Google Maps" loading="lazy">
          </a>
          <a target="_blank" href="https://www.instagram.com/goldschmiede_goldregen/" aria-label="Goldschmiede Goldregen auf Instagram" rel="noopener">
            <img src="@/assets/imgs/instagram.png" alt="Instagram" loading="lazy">
          </a>
          <a target="_blank" href="https://de-de.facebook.com/GoldschmiedeGoldregen" aria-label="Goldschmiede Goldregen auf Facebook" rel="noopener">
            <img src="@/assets/imgs/facebook.png" alt="Facebook" loading="lazy">
          </a>
        </div>
      </div>
      <div class="footer-col">
        <h4 class="footer-heading">Öffnungszeiten</h4>
        <ul class="footer-list">
          <li><span>Di, Do, Fr</span> <span>10–13 &amp; 14–19 Uhr</span></li>
          <li><span>Mittwoch</span> <span>12–19 Uhr</span></li>
          <li><span>Samstag</span> <span>11–14 Uhr</span></li>
        </ul>
      </div>
      <div class="footer-col">
        <h4 class="footer-heading">Kontakt</h4>
        <p class="footer-text">Belgradstr. 136<br>80804 München</p>
        <p class="footer-text">
          <a href="tel:+498945209288" class="footer-link">089 / 452 092 88</a><br>
          <a href="mailto:info@goldregen-muenchen.de" class="footer-link">info@goldregen-muenchen.de</a>
        </p>
      </div>
    </div>
    <div class="footer-bottom">
      <span>© 2010–{{ currentYear }} Goldschmiede Goldregen</span>
      <span class="footer-sep">·</span>
      <a class="footer-link" style="cursor: pointer" @click="clickImpressum()">Impressum</a>
    </div>
  </footer>
</template>

<script>
import { colors } from '@/config'

export default {
  name: 'Footer',
  props: {
    backgroundColor: { type: String, default: 'tourquis' }
  },
  data () {
    return {
      currentYear: new Date().getFullYear()
    }
  },
  computed: {
    getBackgroundColor: function () {
      return this.backgroundColor === 'rose' ? colors.roseBright : colors.turquiseBright
    }
  },
  methods: {
    clickImpressum () {
      if (this.$route.name === 'impressum') {
        return
      }
      this.$routePush('/impressum')
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  color: $color-gr-gray;
  padding: 48px 24px 24px;
  width: 100%;
  margin-top: auto;
}

.footer-inner {
  max-width: 960px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 32px;
  text-align: center;
}

.footer-col {
  flex: 1;
}

.footer-heading {
  font-family: $font-title;
  font-weight: 500;
  font-size: 1em;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin-bottom: 12px;
}

.footer-text {
  font-size: 0.88em;
  line-height: 1.65;
  margin-bottom: 8px;
  opacity: 0.85;
}

.footer-list {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 0.88em;
  line-height: 1.65;
  opacity: 0.85;

  li {
    display: flex;
    justify-content: center;
    gap: 12px;
  }
}

.footer-link {
  color: $color-gr-gray;
  text-decoration: none;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.6;
    color: $color-gr-gray;
  }
}

.footer-social {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 14px;

  a {
    opacity: 0.5;
    transition: opacity 0.25s ease;

    &:hover {
      opacity: 0.85;
    }
  }

  img {
    height: 22px;
  }
}

.footer-bottom {
  max-width: 960px;
  margin: 32px auto 0;
  padding-top: 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  text-align: center;
  font-size: 0.82em;
  opacity: 0.7;
}

.footer-sep {
  margin: 0 8px;
}

@media (min-width: 760px) {
  .footer-inner {
    flex-direction: row;
    text-align: left;
    gap: 48px;
  }

  .footer-list li {
    justify-content: flex-start;
  }

  .footer-social {
    justify-content: flex-start;
  }

  .footer-bottom {
    text-align: left;
  }
}
</style>
